import { createAction } from 'redux-actions'

import { FETCH_PORTS, FETCH_PORTS_ERROR, FETCH_PORTS_SUCCESS } from './consts'

export const fetchPorts = createAction(FETCH_PORTS)
export const fetchPortsSuccess = createAction(FETCH_PORTS_SUCCESS, (payload) => payload)
export const fetchPortsError = createAction(FETCH_PORTS_ERROR)
